import { Col, Row } from "react-bootstrap";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import useTranslator from "../../../hooks/useTranslator";
import { useUpdateGreenRoomLogMutation } from "./greenRoomApi";

const GreenRoomStatusModal = ({ show, setShow, statusForm, setStatusForm }) => {
  const { _t } = useTranslator();
  const [updateGreenRoomLog, { isLoading: isUpdatingLog }] = useUpdateGreenRoomLogMutation();

  const handleClose = () => {
    setShow(false);
    setStatusForm(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStatusForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!statusForm?.id) return;
    try {
      await updateGreenRoomLog({
        id: statusForm.id,
        requestBody: {
          status: statusForm.status,
          total_kg: statusForm.total_kg,
          type: statusForm.type,
          lot_number: statusForm.lot_number,
        },
      }).unwrap();
    } catch (error) {
      console.error("Error updating green room log:", error);
    } finally {
      handleClose();
    }
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={_t("edit_green_room_log_data", "Edit Green Room Log Data")}
    >
      <Row>
        <Col lg={6}>
          <InputWithLabel label={_t("humidity_table_date", "Date")} name="date" type="text" value={statusForm?.created_at || ""} onChange={handleChange} disabled={true} />
        </Col>
        <Col lg={6}>
          <InputWithLabel label={_t("lot_no", "Lot Number")} name="lot_number" type="text" value={statusForm?.lot_number_id || ""} onChange={handleChange} disabled={true} />
        </Col>
        <Col lg={6}>
          <InputWithLabel label={_t("humidity_table_type", "Type")} name="type" type="text" value={statusForm?.type === "cheeks" ? _t("type_cheeks", "Cheeks") : _t("type_strips", "Strips")} onChange={handleChange} disabled={true} />
        </Col>
        <Col lg={6}>
          <InputWithLabel label={_t("total_kg", "Total Kg")} name="total_kg" type="text" value={statusForm?.total_kg ?? ""} onChange={handleChange} disabled={true} />
        </Col>
        <Col lg={12}>
          <SelectBox
            label={_t("status", "Status")}
            name="status"
            value={statusForm?.status || "accumulated"}
            onChange={handleChange}
            options={[
              { value: "accumulated", label: _t("accumulated", "Accumulated") },
              { value: "processed", label: _t("processed", "Processed") },
            ]}
          />
        </Col>
      </Row>
      <Row>
        <Col className="text-end">
          <Button label={_t("save_changes", "Save Changes")} size="small" onClick={handleSave} disabled={isUpdatingLog} />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default GreenRoomStatusModal;
